import {
  firstDateOfMonth, last7, lastDays, today,
} from '@/store/helpers'

import { DAY_MONTH_YEAR } from '@/libs/filterDate'

export const DEFAULT_CONFIG = {
  thStyle: {
    textTransform: 'capitalize',
    whiteSpace: 'nowrap',
    fontSize: '14px',
    fontWeight: '500',
    color: '#333',
    background: '#F4F4F4',
    padding: '12px 8px',
    textAlign: 'left',
  },
  tdClass: 'text-[#333] !py-[12px] !px-[8px] text-[14px]',
}

export const CREATOR_DATA_TABS = ['Semua', 'TAP', 'MCN', 'Suspend', 'Blacklisted']

export const CREATOR_DISTRIBUTION_TABS = ['Semua', 'Assign', 'Unassign']

export const CREATOR_DATA_FIELDS = [
  { key: 'id', label: 'No', center: true },
  { key: 'name', label: 'Nama Lengkap' },
  { key: 'phone', label: 'Nomor HP', formatter: value => value?.replace(/^0?8/, '628') },
  { key: 'category', label: 'Kategori' },
  { key: 'register_date', label: 'Tanggal Register', formatter: value => (value ? DAY_MONTH_YEAR(value) : '-') },
  { key: 'status', label: 'Status' },
].map(column => {
  const rest = {
    thStyle: { ...DEFAULT_CONFIG.thStyle },
    tdClass: DEFAULT_CONFIG.tdClass,
  }
  if (column.label === 'No') {
    rest.thStyle.minWidth = '44px'
  }
  if (column.center) {
    rest.thStyle.textAlign = 'center'
    rest.tdClass += ' text-center'
  }
  return { ...column, ...rest }
})

export const datePickerRange = (current = today) => ({
  'Hari Ini': [today, today],
  '7 Hari Terakhir': [last7, today],
  '10 Hari Terakhir': [lastDays(10), today],
  'Bulan Ini': [firstDateOfMonth, today],
})

export const CREATOR_DISTRIBUTION_FIELDS = [
  { key: 'no', label: 'No', center: true },
  { key: 'name', label: 'Nama Lengkap' },
  { key: 'phone', label: 'Nomor HP', formatter: value => value?.replace(/^0?8/, '628') },
  { key: 'category', label: 'Kategori' },
  { key: 'ongoing_campaigns', label: 'Ongoing Campaign', formatter: value => value?.join(', ') || '-' },
  { key: 'total_campaigns', label: 'Total Campaign', formatter: value => `${value} Campaign` || '-' },
].map(column => {
  const rest = {
    thStyle: { ...DEFAULT_CONFIG.thStyle },
    tdClass: DEFAULT_CONFIG.tdClass,
  }
  if (column.label === 'No') {
    rest.thStyle.minWidth = '44px'
  }
  if (column.center) {
    rest.thStyle.textAlign = 'center'
    rest.tdClass += ' text-center'
  }
  return { ...column, ...rest }
})

export const UPGRADE_STATUS_FIELDS = [
  { key: 'no', label: 'No', center: true },
  { key: 'name', label: 'Nama Lengkap' },
  { key: 'phone', label: 'Nomor HP', formatter: value => value?.replace(/^0?8/, '628') },
  { key: 'category', label: 'Kategori' },
  { key: 'ongoing_campaigns', label: 'Followed Campaign', formatter: value => value?.join(', ') || '-' },
  { key: 'status', label: 'Status' },
  { key: 'total_campaigns', label: 'Total Campaign', formatter: value => `${value} Campaign` },
].map(column => {
  const rest = {
    thStyle: { ...DEFAULT_CONFIG.thStyle },
    tdClass: DEFAULT_CONFIG.tdClass,
  }
  if (column.label === 'No') {
    rest.thStyle.minWidth = '44px'
  }
  if (column.center) {
    rest.thStyle.textAlign = 'center'
    rest.tdClass += ' text-center'
  }
  return { ...column, ...rest }
})

export const UPGRADE_STATUS_OPTIONS = {
  tap: 'TAP',
  mcn: 'MCN',
  blacklisted: 'Blacklisted',
  off: 'Suspend',
}

export const UPGRADE_STATUS_OPTION_LIST = [
  { value: 'tap', text: 'TAP' },
  { value: 'mcn', text: 'MCN' },
  { value: 'blacklisted', text: 'Blacklisted' },
  { value: 'off', text: 'Suspend' },
]

export const UNDEFINED_STATUS_TEXT = 'Pilih Status'

export const CREATOR_STATUS_STYLE = {
  tap: {
    label: 'TAP',
    borderColor: '#FBA63C',
    class: '!bg-[#FCEBBE] !text-[#AF6A13] !border-[#FBA63C] hover:!bg-[#FCEBBE] hover:!text-[#AF6A13] hover:!border-[#FBA63C]',
  },
  mcn: {
    label: 'MCN',
    borderColor: '#4285F4',
    class: '!bg-[#D9E7FD] !text-[#376FCB] !border-[#4285F4] hover:!bg-[#D9E7FD] hover:!text-[#376FCB] hover:!border-[#4285F4]',
  },
  off: {
    label: 'Suspend',
    borderColor: '#E31A1A',
    class: '!bg-[#FFEDED] !text-[#E31A1A] !border-[#E31A1A] hover:!bg-[#FFEDED] hover:!text-[#E31A1A] hover:!border-[#E31A1A]',
  },
  blacklisted: {
    label: 'Blacklisted',
    borderColor: '#333333',
    class: '!bg-[#F4F4F4] !text-[#333333] !border-[#C2C2C2] hover:!bg-[#F4F4F4] hover:!text-[#333333] hover:!border-[#C2C2C2]',
  },
}

export const CREATOR_CATEGORY_OPTIONS = [
  {
    value: 'Beauty',
    text: 'Beauty',
  },
  {
    value: 'Fashion',
    text: 'Fashion',
  },
  {
    value: 'F&B',
    text: 'F&B',
  },
  {
    value: 'Mom & Kids',
    text: 'Mom & Kids',
  },
  {
    value: 'Elektronik',
    text: 'Elektronik',
  },
  {
    value: 'Rumah Tangga',
    text: 'Rumah Tangga',
  },
  {
    value: 'Lain Lain',
    text: 'Lain Lain',
  },
]
